import storage from "local-storage-fallback";

import { privateTvClient } from "./client";

const requestTvPayment = data =>
  privateTvClient.post(`/customers/${storage.getItem("identifier")}/payment`, JSON.stringify(data));

export { requestTvPayment };
